import Vue from 'vue';
import apiKeysServices from '../api/ApiKeys';
import appServices from '../api/App';
import appLogsServices from '../api/AppLogs';
import appSystemServices from '../api/AppSystem';
import appSystemsServices from '../api/AppSystems';
import appSystemWebApisServices from '../api/AppSystemWebApis';
import authServices from '../api/Auth';
import callLogsServices from '../api/CallLogs';
import contactIdMappingsServices from '../api/ContactIdMappings';
import documentsServices from '../api/Documents';
import dynamicFormServices from '../api/DynamicForm';
import fieldMappingServices from '../api/FieldMapping';
import httpMethodLookupServices from '../api/HttpMethodLookup';
import integrationCallsServices from '../api/IntegrationCalls';
import integrationTasksServices from '../api/IntegrationTasks';
import learnitBaseDataServices from '../api/LearnitBaseData';
import learnitDataItemsServices from '../api/LearnitDataItems';
import learnitTagsServices from '../api/LearnitTags';
import locationsServices from '../api/Locations';
import meServices from '../api/Me';
import onlinePaymentTransactionServices from '../api/OnlinePaymentTransaction';
import processesServices from '../api/Processes';
import requestFormsServices from '../api/RequestForms';
import sequencenumbersServices from '../api/Sequencenumbers';
import tenantsServices from '../api/Tenants';
import usersServices from '../api/Users';
import widgetHostConfigsServices from '../api/WidgetHostConfigs';

export default () => ({
  apiKeys: { ...apiKeysServices(Vue.$service) },
  app: { ...appServices(Vue.$service) },
  appLogs: { ...appLogsServices(Vue.$service) },
  appSystem: { ...appSystemServices(Vue.$service) },
  appSystems: { ...appSystemsServices(Vue.$service) },
  appSystemWebApis: { ...appSystemWebApisServices(Vue.$service) },
  auth: { ...authServices(Vue.$service) },
  callLogs: { ...callLogsServices(Vue.$service) },
  contactIdMappings: { ...contactIdMappingsServices(Vue.$service) },
  documents: { ...documentsServices(Vue.$service) },
  dynamicForm: { ...dynamicFormServices(Vue.$service) },
  fieldMapping: { ...fieldMappingServices(Vue.$service) },
  httpMethodLookup: { ...httpMethodLookupServices(Vue.$service) },
  integrationCalls: { ...integrationCallsServices(Vue.$service) },
  integrationTasks: { ...integrationTasksServices(Vue.$service) },
  learnitBaseData: { ...learnitBaseDataServices(Vue.$service) },
  learnitDataItems: { ...learnitDataItemsServices(Vue.$service) },
  learnitTags: { ...learnitTagsServices(Vue.$service) },
  locations: { ...locationsServices(Vue.$service) },
  me: { ...meServices(Vue.$service) },
  onlinePaymentTransaction: { ...onlinePaymentTransactionServices(Vue.$service) },
  processes: { ...processesServices(Vue.$service) },
  requestForms: { ...requestFormsServices(Vue.$service) },
  sequencenumbers: { ...sequencenumbersServices(Vue.$service) },
  tenants: { ...tenantsServices(Vue.$service) },
  users: { ...usersServices(Vue.$service) },
  widgetHostConfigs: { ...widgetHostConfigsServices(Vue.$service) },
});
